import { DATASETS } from '../components/Constants';

class GDAModel {
  geneNcbiID: number;
  geneSymbol: string;
  geneDescription: string;
  geneProteinStrIDs: string;
  diseaseName: string;
  diseaseUMLSCUI: string;
  numDiseasesAssociatedToGene: number;
  numVariantsAssociatedToGene: number;
  numGenesAssociatedToDisease: number;
  numVariantsAssociatedToDisease: number;
  numPMIDsupportingAssociation: number;
  numDBSNPsupportingAssociation: number;
  pmid: string;
  score: number;
  EI: number | null;
  numPmidsWithChemsEvidence: number;
  numberNCTSWithChemsIncludedInEvidence: number;
  numberChemsIncludedInEvidence: number;
  numPmidsWithChemsFiltered: number;
  geneEnsemblIDs: string;

  constructor(data: any) {
    this.geneNcbiID = data.geneNcbiID;
    this.geneSymbol = data.geneSymbol;
    this.geneDescription = data.geneDescription;
    this.geneProteinStrIDs = data.geneProteinStrIDs;
    this.diseaseName = data.diseaseName;
    this.diseaseUMLSCUI = data.diseaseUMLSCUI;
    this.numDiseasesAssociatedToGene = data.numDiseasesAssociatedToGene;
    this.numVariantsAssociatedToGene = data.numVariantsAssociatedToGene;
    this.numGenesAssociatedToDisease = data.numGenesAssociatedToDisease;
    this.numVariantsAssociatedToDisease = data.numVariantsAssociatedToDisease;
    this.numPMIDsupportingAssociation = data.numPMIDsupportingAssociation;
    this.numDBSNPsupportingAssociation = data.numDBSNPsupportingAssociation;
    this.pmid = data.pmid;
    this.score = data.score;
    this.EI = this.transformEIValue(data.EI);
    this.numPmidsWithChemsEvidence = data.numberPmidsWithChemsIncludedInEvidence;
    this.numberNCTSWithChemsIncludedInEvidence = data.numberNCTSWithChemsIncludedInEvidence;
    this.numberChemsIncludedInEvidence = data.numberChemsIncludedInEvidence;
    this.numPmidsWithChemsFiltered = data.numberPmidsWithChemsFiltered;
    this.geneEnsemblIDs = data.geneEnsemblIDs;
  }

  transformEIValue(eiValue: number | null): number | null {
    return eiValue !== null ? Number(eiValue.toFixed(2)) : null;
  }
}

class GDATable extends GDAModel {
  constructor(data: any) {
    super(data);
  }

  get valueGene() {
    return [this.geneNcbiID];
  }

  get valueDisease() {
    return `UMLS_${this.diseaseUMLSCUI}`;
  }

  getNameGene() {
    const nameGene: Array<{ name: string; value: number | string; title: string }> = [
      { name: `${this.geneSymbol}, ${this.geneDescription}`, value: this.geneNcbiID, title: DATASETS.GENES },
    ];

    return nameGene;
  }

  getNameDisease() {
    const nameDisease: Array<{ name: string; value: number | string; title: string }> = [
      {
        name: `${this.diseaseName}, ${this.diseaseUMLSCUI}`,
        value: this.valueDisease,
        title: DATASETS.DISEASES,
      },
    ];

    return nameDisease;
  }

  getNameDG() {
    const nameGene = this.getNameGene();
    const nameDisease = this.getNameDisease();

    const nameDG = nameGene.concat(nameDisease);
    return nameDG;
  }
}

export { GDAModel, GDATable };
